import { BitubeProperties } from '@src/routes/Configurators/products/BiTube/enum'
import axios from 'axios'
import { saveAs } from 'file-saver'

export const validateText = (data: string) => {
  return data.replace(/%/g, '')
}

/*GA data for semiConfigurator Products
  common method to use it in summary.tsx files  for GA
  uncommon method (not formatting price) only for KicqstartProbes and SiRNA
 */

export const getSemiConfiguratorGAdata = (
  obj,
  itemName,
  locale,
  currencyFormat,
  formatPrice
) => {
  const qty = obj?.length || 1
  let productPrice = 0

  const averagePrice = () => {
    if (obj && !Array.isArray(obj)) {
      return obj?.pricing?.price || 0
    }
    obj.forEach((product) => {
      if (
        product.price &&
        product.price.toString() !== BitubeProperties.Quote
      ) {
        productPrice = productPrice + Number(product.price)
      } else {
        productPrice = productPrice + 1
      }
    })
    return (productPrice / qty).toFixed(Number(currencyFormat))
  }
  let avgPrice = averagePrice()

  if (formatPrice) {
    const gaPrice = avgPrice.slice(0, avgPrice.length - 3).replace(/[.,]/g, '')
    avgPrice = gaPrice + avgPrice.slice(avgPrice.length - 3, avgPrice.length)
  }

  return {
    productDetails: obj,
    totalQuantity: qty,
    price: `${avgPrice}`,
    productName: itemName,
  }
}
export const handleSemiConfigDownLoadOrderSummary = async (
  e,
  productType,
  fileName,
  data
) => {
  e.preventDefault()
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ data: data }),
  }

  try {
    const response = await fetch(
      `/semiconfigurator-order/summary/${productType}`,
      requestOptions
    )
    const blob = await response.blob()
    const blobObject = new Blob([blob], { type: 'application/vnd.ms-excel' })

    const url = window.URL.createObjectURL(blobObject)
    saveAs(url, fileName)
  } catch (error) {
    console.error('Download failed', error)
  }
}

export const handleKicqStartGeneArrayDownloadSummary = async (
  e,
  fileName,
  productDetails
) => {
  e.preventDefault()
  axios({
    url: `/semiconfig/order/summary/${productDetails.productType}?participantId=${productDetails.participantId}&country=${productDetails.countryCode}&locale=${productDetails.locale}`,
    method: 'GET',
    headers: { Pragma: 'no-cache' },
    responseType: 'blob', // important
  })
    .then((response: any) => {
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      // Append to html page
      document.body.appendChild(link)
      // Force download
      link.click()
    })
    .catch((error) => {
      error.json().then(() => {
        // Added comment for avoid es-lint error
      })
    })
}

export const isIEBrowser = () => {
  return !!window.document['documentMode']
}

export const regex = /^[^a-zA-Z0-9]+$/
